/**
 * 验证手机号格式
 */
const checkPhoneNum = function (phoneNum) {
  // debugger
  var myreg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  var tempStatus = false;
  if (phoneNum.length == 11 && myreg.test(phoneNum)) {
    tempStatus = true;
  }
  return tempStatus;
}

// 校验email
const checkEmail = function (email) {
  var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
  if (email === "") { //输入不能为空
    return false;
  } else if (!reg.test(email)) { //正则验证不通过，格式不对
    return false;
  } else {
    return true;
  }
}

// 格式化
const convertDate = function(row, column, cellValue, index){
  const daterc = row[column.property]
  if(daterc!=null){
    const dateMat= new Date(daterc);
    const year = dateMat.getFullYear();
    let month = dateMat.getMonth() + 1;
    let day = dateMat.getDate();
    let hh = dateMat.getHours();
    let mm = dateMat.getMinutes();
    let ss = dateMat.getSeconds();
    month = month < 10 ? '0'+month : month;
    day = day < 10 ? '0'+day : day;
    hh = hh < 10 ? '0'+hh : hh;
    mm = mm < 10 ? '0'+mm : mm;
    ss = ss < 10? '0'+ss : ss;
    const timeFormat= year + "-" + month + "-" + day + " " + hh + ":" + mm + ":" + ss;
    return timeFormat;
  }
}

// 格式化日期 Thu Mar 07 2019 12:00:00 GMT+0800 (中国标准时间) 转换为 2019-03-07
const forTime = function (val) {
  const d = new Date(val)
  const resDate = d.getFullYear() + '-' + this.repairZero((d.getMonth() + 1)) + '-' + this.repairZero(d.getDate())
  const resTime = this.repairZero(d.getHours()) + ':' + this.repairZero(d.getMinutes()) + ':' + this.repairZero(d.getSeconds())
  return resDate
}

// 格式化时间 Thu Mar 07 2019 12:00:00 GMT+0800 (中国标准时间) 转换为 12:00:00
const formatTime = function (val) {
  const d = new Date(val)
  const resDate = d.getFullYear() + '-' + this.repairZero((d.getMonth() + 1)) + '-' + this.repairZero(d.getDate())
  const resTime = this.repairZero(d.getHours()) + ':' + this.repairZero(d.getMinutes()) + ':' + this.repairZero(d.getSeconds())
  return resTime
}
// 格式化时间1
const formateDate = function (date) {
  var arr=date.split("T");
  var d=arr[0];
  var darr = d.split('-');

  var t=arr[1];
  var tarr = t.split('.000');
  var marr = tarr[0].split(':');

  var dd = parseInt(darr[0])+"/"+parseInt(darr[1])+"/"+parseInt(darr[2])+" "+parseInt(marr[0])+":"+parseInt(marr[1])+":"+parseInt(marr[2]);
  return this.formatDateTime(dd)
}

// 格式化时间2
const formatDateTime = function (date) {
  let time = new Date(Date.parse(date));
  time.setTime(time.setHours(time.getHours() + 8));
  let Y = time.getFullYear() + '-';
  let M = this.repairZero(time.getMonth() + 1) + '-';
  let D = this.repairZero(time.getDate()) + ' ';
  let h = this.repairZero(time.getHours()) + ':';
  let m = this.repairZero(time.getMinutes()) + ':';
  let s = this.repairZero(time.getSeconds());
  return Y + M + D + h + m + s;
}

// 补零
const repairZero = function (s) {
  return s < 10 ? '0' + s : s
}

/**
 * 格式化秒
 * @param int  value 总秒数
 * @return string result 格式化后的字符串
 */
function formatSeconds(value) {
  var theTime = parseInt(value);// 需要转换的时间秒
  var theTime1 = 0;// 分
  var theTime2 = 0;// 小时
  var theTime3 = 0;// 天
  if(theTime > 60) {
   theTime1 = parseInt(theTime/60);
   theTime = parseInt(theTime%60);
   if(theTime1 > 60) {
    theTime2 = parseInt(theTime1/60);
    theTime1 = parseInt(theTime1%60);
    if(theTime2 > 24){
     //大于24小时
     theTime3 = parseInt(theTime2/24);
     theTime2 = parseInt(theTime2%24);
    }
   }
  }
  var result = '';
  if(theTime > 0){
   result = ""+parseInt(theTime)+"秒";
  }
  if(theTime1 > 0) {
   result = ""+parseInt(theTime1)+"分"+result;
  }
  if(theTime2 > 0) {
   result = ""+parseInt(theTime2)+"小时"+result;
  }
  if(theTime3 > 0) {
   result = ""+parseInt(theTime3)+"天"+result;
  }
  return result;
 }

/**
 * randomWord 产生任意长度随机字母数字组合
 * randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
 * xuanfeng 2014-08-28
 */
const getRandomVerify = function (randomFlag, min, max) {
  var str = "",
  range = min,
  arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min;
  }
  for (var i = 0; i < range; i++) {
    var pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
}





export {
  checkPhoneNum,
  checkEmail,
  getRandomVerify,
  convertDate,
  forTime,
  formatTime,
  formateDate,
  formatDateTime,
  repairZero,
  formatSeconds,
}



// WEBPACK FOOTER //
// ./src/utils/util.js